import { useState } from 'react';
import AutoformUiContext from './utils/AutoformUiContext';

const AutoformUiProvider = ({ children }) => {
    const [editingState, setEditingState] = useState({});

    return (
        <AutoformUiContext.Provider value={{ editingState, setEditingState }}>{children}</AutoformUiContext.Provider>
    );
};

export default AutoformUiProvider;
